module.exports = __webpack_public_path__ + "img/mauritania.aa72dd9d.svg";